import { Injectable } from '@angular/core';
import { BackendService } from './backend.service';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LmRecommends } from '../models';

@Injectable({
  providedIn: 'root',
})
export class BookService {
  constructor(private backendService: BackendService) {}

  getLmRecommends(): Observable<LmRecommends[]> {
    const url = `${environment.baseUrl}/books/recommend/`;

    return this.backendService.get(url).pipe(
      map((response) => {
        const res = response?.data ?? [];
        if (res.length) {
          res.map((book: LmRecommends) => {
            book.avatar = `${decodeURI(book.cover_image)}?alt=media`;
            book.category_name = book.category.category_name;
          });
        }
        return res;
      }),
      catchError((errorRes) => throwError(errorRes)),
    );
  }
}
